export const getFeatureFlags = (state) =>
  state?.featureFlags?.data ?? {}

export const getIsLoadingFeatureFlags = (state) =>
  state?.featureFlags?.isLoading ?? false
